var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWarning(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.00137 23.0075H22.0614C23.6014 23.0075 24.5614 21.3375 23.7914 20.0075L16.2614 6.9975C15.4914 5.6675 13.5714 5.6675 12.8014 6.9975L5.27137 20.0075C4.50137 21.3375 5.46137 23.0075 7.00137 23.0075ZM14.5314 16.0075C13.9814 16.0075 13.5314 15.5575 13.5314 15.0075V13.0075C13.5314 12.4575 13.9814 12.0075 14.5314 12.0075C15.0814 12.0075 15.5314 12.4575 15.5314 13.0075V15.0075C15.5314 15.5575 15.0814 16.0075 14.5314 16.0075ZM15.5314 20.0075H13.5314V18.0075H15.5314V20.0075Z",
    fill: "#ADB8CC"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarning);
export default __webpack_public_path__ + "static/media/warning.e27199da549ea681be6e76a82ab1b11a.svg";
export { ForwardRef as ReactComponent };